import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';

export const space = css`
  & > * {
    width: 100%;
  }

  ${mediaQuery('medium', 'min')} {
    & > *:nth-of-type(1) {
      width: 25%;
      white-space: break-spaces;
    }

    & > *:nth-of-type(2) {
      width: 25%;
    }

    & > *:nth-of-type(3) {
      width: 25%;
    }

    & > *:nth-of-type(4) {
      width: 15%;
    }

    & > *:nth-of-type(5) {
      text-align: right;
      width: 10%;
    }
  }
`;

const mobileLabel = css`
  ${mediaQuery('medium', 'max')} {
    &:before {
      content: attr(data-title);
      display: inline-block;
      margin-right: 12px;
      font-weight: 600;
      width: 80px;
      word-break: keep-all;
    }
  }
`;

export const Table = styled.div``;

export const TableHead = styled.div`
  display: none;

  ${mediaQuery('medium', 'min')} {
    display: flex;
    justify-content: space-between;
    padding: 16px;
    font-weight: 600;
    ${space};
  }
`;

export const TableRow = styled.div`
  border-radius: 16px;
  box-shadow: -1px 3px 16px rgba(149, 157, 165, 0.19);
  padding: 10px 25px;

  ${mediaQuery('medium', 'min')} {
    display: flex;
    justify-content: space-between;
    ${space};
  }
`;

export const TableRowLabel = styled.label`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  right: 0;
  z-index: 1;
  cursor: pointer;

  ${mediaQuery('medium', 'min')} {
    display: none;
  }
`;

export const TableCell = styled.div`
  ${mobileLabel};
  display: flex;
  align-items: center;
  padding: 10px;
  text-align: left;

  ${mediaQuery('medium', 'max')} {
    &:nth-of-type(5) {
      position: absolute;
      right: 30px;
      top: 40%;
    }
  }
`;

export const ImageNameWrapper = styled.div`
  display: flex;
  align-items: center;
  z-index: 2;

  ${mediaQuery('medium')} {
    a,
    button {
      margin-left: 8px;
      padding: 0;
    }
  }
`;

export const BreedNameWrapper = styled.div`
  ${mediaQuery('medium')} {
    max-width: 100px;
    word-break: normal;
  }
`;

export const ButtonWrapper = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
  gap: 14px;
`;
